import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface Props {
  title: string;
  accentColor?: string;
  children: React.ReactNode;
  stretch?: boolean;  // fill parent height when paired side-by-side in a row
}

export default function KpiModuleCard({ title, accentColor = '#1C60A5', children, stretch }: Props) {
  return (
    <View style={[styles.card, stretch && styles.cardStretch]}>
      <View style={[styles.header, { backgroundColor: accentColor + '12', borderLeftColor: accentColor }]}>
        <Text style={[styles.title, { color: accentColor }]}>{title}</Text>
      </View>
      <View style={styles.body}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#fff',
    borderRadius: 10,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
    overflow: 'visible' as any,
  },
  cardStretch: {
    flex: 1,
  },
  header: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderLeftWidth: 4,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  title: {
    fontSize: 13,
    fontWeight: '800',
    textTransform: 'uppercase',
    letterSpacing: 0.6,
  },
  body: {
    padding: 14,
  },
});
